import { useEffect, useMemo, useState } from 'react';

import { AuthService, UserRoles } from 'shared/lib/keycloak';
import {
  TEXAS_EDUCATION_AGENCY_MUNICIPALITY_ORG_SIS_ID,
  useUserOrgs,
} from 'shared/api/onboarding';

export const useAdminPortalEntitlement = () => {
  const [isEntitledToAdminPortal, setIsEntitledToAdminPortal] = useState(false);
  const { activeOrgs, schools, districts, isLoading } = useUserOrgs();

  const isTeacher = AuthService.getRole() === UserRoles.TEACHER;

  const isTexasOnly = useMemo(() => {
    return (
      activeOrgs.length === 1 &&
      activeOrgs[0].sourcedId === TEXAS_EDUCATION_AGENCY_MUNICIPALITY_ORG_SIS_ID
    );
  }, [activeOrgs]);

  const hasAlternativeErrorMsg = useMemo(() => {
    if (isLoading) return false;
    return isTeacher && !isTexasOnly && districts.length > 0;
  }, [districts, isLoading, isTeacher, isTexasOnly]);

  useEffect(() => {
    if (isLoading) return;

    // if user is a teacher and is in an onboarding school or district and is not in a Texas org only
    // then it he is entitled to use Admin Portal
    const isEntitled =
      isTeacher && !isTexasOnly && !!(districts.length || schools.length);

    setIsEntitledToAdminPortal(isEntitled);
  }, [activeOrgs, schools, districts, isLoading, isTeacher, isTexasOnly]);

  return {
    isEntitledToAdminPortal,
    orgs: activeOrgs,
    isLoading,
    hasAlternativeErrorMsg,
  };
};
